import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import SchedulingModal from '../components/SchedulingModal';

interface SchedulingContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const SchedulingContext = createContext<SchedulingContextValue | null>(null);

export const SchedulingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close]);

  return (
    <SchedulingContext.Provider value={value}>
      {children}
      <SchedulingModal isOpen={isOpen} onClose={close} />
    </SchedulingContext.Provider>
  );
};

export const useScheduling = (): SchedulingContextValue => {
  const context = useContext(SchedulingContext);
  if (!context) {
    throw new Error('useScheduling must be used inside <SchedulingProvider>');
  }
  return context;
};
